import { render } from "./refund-detail.vue?vue&type=template&id=5b0a9b63&scoped=true"
import script from "./refund-detail.vue?vue&type=script&lang=js"
export * from "./refund-detail.vue?vue&type=script&lang=js"

import "./refund-detail.vue?vue&type=style&index=0&id=5b0a9b63&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0a9b63"]])

export default __exports__